import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {activateNiud, setFormErrors, clearApiError, resetState} from './BusinessActivateNiudSlice';
import {validateActivateNiudForm, IdNumberType} from '../../../utilities/validation/idNumberValidation';
import {formatExpectedPortTime, getContactOrgId} from './constants';
import IdDetailsSection from './components/IdDetailsSection';
import PhoneNumbersSection from './components/PhoneNumbersSection';
import ActivateNiudResultMessage from './components/ActivateNiudResultMessage';
import './BusinessActivateNiudMain.scss';

const BusinessActivateNiudMain = ({
  iContent,
  formErrors,
  apiError,
  apiErrorMessage,
  apiSuccessMessage,
  isCompleted,
  expectedPortTime,
  activateNiud,
  setFormErrors,
  clearApiError,
  resetState,
  contactOrgId,
}) => {
  const [form, setForm] = useState({
    idNumberType: IdNumberType.Company,
    idNumber: '',
    hostNumber: '',
    niudNumber: '',
  });

  useEffect(() => {
    return () => resetState();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFieldChange = (field, value) => {
    clearApiError();
    setForm((prev) => ({...prev, [field]: value}));
    if (formErrors[field]) {
      setFormErrors({...formErrors, [field]: ''});
    }
  };

  const handlePhoneChange = (field, e) => {
    const currentItem = e.nativeEvent?.data;
    const regex = /^\d+$/;
    if (regex.test(currentItem) || !e.nativeEvent?.data) {
      handleFieldChange(field, e.target.value);
    }
  };

  const handleContinue = async () => {
    const validation = validateActivateNiudForm(form);
    if (!validation.isValid) {
      setFormErrors(validation.errors);
      return;
    }

    setFormErrors({});
    await activateNiud({
      ...form,
      contactOrgId,
    });
  };

  const handleBackToBusinessLobby = () => {
    EpiContext.navigateTo(Config.businessLobbyUrl);
  };

  const continueButtonText = iContent?.continueButtonText?.value || 'המשך';
  const title = iContent?.title?.value;
  const boldTitle = iContent?.boldTitle?.value;
  const formattedPortTime = formatExpectedPortTime(expectedPortTime);

  return (
    <div className='businessActivateNiud'>
      <div className='activate-niud-step'>
        {title && <div className='L_Title'>{title}</div>}
        {boldTitle && <div className='M_Sub_Title center'>{boldTitle}</div>}

        {!isCompleted && (
          <>
            <IdDetailsSection form={form} formErrors={formErrors} onFieldChange={handleFieldChange} />
            <PhoneNumbersSection form={form} formErrors={formErrors} onPhoneChange={handlePhoneChange} />
          </>
        )}

        <ActivateNiudResultMessage
          type='error'
          apiError={apiError}
          apiErrorMessage={apiErrorMessage}
        />

        {isCompleted && (
          <ActivateNiudResultMessage
            type='success'
            apiSuccessMessage={apiSuccessMessage}
            formattedPortTime={formattedPortTime}
          />
        )}

        <div className='continue-button'>
          {!isCompleted ? (
            <BtnSubmit isBusiness text={continueButtonText} onclick={handleContinue} />
          ) : (
            <BtnWhite isBusiness text='לחזרה לאיזור אישי עסקי' onclick={handleBackToBusinessLobby} />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  formErrors: state.BusinessActivateNiudSlice?.formErrors || {},
  apiError: state.BusinessActivateNiudSlice?.apiError,
  apiErrorMessage: state.BusinessActivateNiudSlice?.apiErrorMessage,
  apiSuccessMessage: state.BusinessActivateNiudSlice?.apiSuccessMessage,
  isCompleted: state.BusinessActivateNiudSlice?.isCompleted,
  expectedPortTime: state.BusinessActivateNiudSlice?.expectedPortTime,
  contactOrgId: getContactOrgId(state.portalsBlock),
});

const mapDispatchToProps = {
  activateNiud,
  setFormErrors,
  clearApiError,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessActivateNiudMain);
